"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, LoadingState } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsLoadingState() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Loading State
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Displays a loading indicator with optional text for async operations.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/loading-state" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Variants</CardTitle>
              <CardDescription>Different loading state styles</CardDescription>
            </>
          }
          contentClassName="p-6 space-y-8"
        >
          <div className="space-y-4">
            <Text className="text-sm font-medium">Default</Text>
            <div className="h-32 border rounded-lg flex items-center justify-center">
              <LoadingState />
            </div>
          </div>

          <div className="space-y-4">
            <Text className="text-sm font-medium">With Message</Text>
            <div className="h-32 border rounded-lg flex items-center justify-center">
              <LoadingState message="Loading data..." />
            </div>
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Default</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">message</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 font-mono text-xs">-</td>
                <td className="py-2 text-muted-foreground">Loading message to display</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">size</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">"sm" | "md" | "lg" | "xl"</td>
                <td className="py-2 font-mono text-xs">"md"</td>
                <td className="py-2 text-muted-foreground">Size of the spinner</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
